import { Injectable } from '@angular/core'
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { TranslateService } from '@ngx-translate/core'
import { Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import { HttpStatusCodes } from '../models/enums/http-status-codes '

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private toaster: ToastrService,
    private translate: TranslateService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next
      .handle(request)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler(error)))
  }

  private errorHandler(
    response: HttpErrorResponse
  ): Observable<HttpEvent<any>> {
    switch (response.status) {
      case HttpStatusCodes.ConnectionError:
        this.handleConnectionError(response)
        break
      case HttpStatusCodes.Unauthorized:
      case HttpStatusCodes.Forbidden:
        this.handleAuthError()
        break
      case HttpStatusCodes.BadRequest:
        this.handleBadRequest(response)
        break
      case HttpStatusCodes.Conflict:
        this.handleConflict(response)
        break
      case HttpStatusCodes.UnprocessableEntity:
        this.handleUnprocessableEntity(response)
        break
      case HttpStatusCodes.InternalServerError:
        this.toaster.error(
          this.translate.instant('Common-Msg.Internal-Server-Error-Message')
        )
        break
      case HttpStatusCodes.GatewayTimeout:
        this.toaster.error(
          this.translate.instant('Common-Msg.Network-Error-Message')
        )
        break
      default:
        this.handleGenericError()
        break
    }
    return throwError(() => response)
  }

  private handleConnectionError(response: HttpErrorResponse): void {
    if (response.error instanceof ProgressEvent) {
      this.toaster.error(
        this.translate.instant('Common-Msg.Network-Error-Message')
      )
    }
  }

  private handleAuthError(): void {
    localStorage.removeItem('userMail')
    localStorage.removeItem('authToken')
    localStorage.removeItem('user')
    localStorage.removeItem('pusherTransportTLS')
    this.router.navigate(['/login'])
    // this.toaster.error(this.translate.instant('Msg-Not-Authorized'));
  }

  private handleBadRequest(response: HttpErrorResponse): void {
    const errors = response.error?.Error?.errors
    if (errors) {
      for (const key in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, key)) {
          errors[key].forEach((msg: string) => {
            this.toaster.error(msg)
          })
        }
      }
    }
  }

  private handleConflict(response: HttpErrorResponse): void {
    // BusinessException(409) is wrapped as { Data: { ErrorMessage, ... }, ... } — show the
    // server-provided reason (e.g. "This email is already in use") instead of a generic toast.
    const message = response.error?.Data?.ErrorMessage
    this.toaster.error(
      message || this.translate.instant('Common-Msg.Error-Happened')
    )
  }

  private handleUnprocessableEntity(response: HttpErrorResponse): void {
    const errorMessage = response.error?.Data?.ErrorMessage
    if (errorMessage) {
      this.toaster.error(errorMessage)
    }
  }

  private handleGenericError(): void {
    this.toaster.error(this.translate.instant('Common-Msg.Error-Happened'))
  }
}
